import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { addSecret, testAzureConnection } from "../../api's/ConnectorsApi";
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { AWS_CONFIG_TYPE } from '../../BaseUrl';

const INITIAL_STATE = {
  secretName: '',
  connectorType: 'adls',
  engine: 'adls',
  storageAccountKey: '',
  storageAccount: '',
  containerName: '',
  endpointSuffix: '',
};

const ADLSDatalakeConnectorForm = ({ open, handleClose, service }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);
  const [isConnectionSucceeded, setIsConnectionSucceeded] = useState(false);
  const [errors, setErrors] = useState({ secretName: false });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'secretName') {
      const pattern = AWS_CONFIG_TYPE
        ? /^[a-z][a-z0-9_]{0,29}$/
        : /^[a-z][a-z0-9-]{0,29}$/;

      const isValid = pattern.test(value);
      setErrors((prev) => ({ ...prev, [name]: !isValid }));
    } else {
      setIsConnectionSucceeded(false);
    }

    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const secretResponse = await addSecret(formData);
      console.log(secretResponse);
      if (secretResponse.status === 201 || secretResponse.status === 200) {
        enqueueSnackbar(secretResponse?.data, {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }

    setLoading(false);
    console.log('Connecting with:', formData);
  };

  const testDatabaseConnection = async (e) => {
    e.preventDefault();
    console.log('Testing connection');
    setLoading(true);
    try {
      const response = await testAzureConnection(formData);
      if (response.status === 200) {
        enqueueSnackbar('Test Connection Successful', {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      setIsConnectionSucceeded(true);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {service?.name} Connection
        <IconButton onClick={handleClose} size="small" sx={{ color: 'red' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form autoComplete="off" onSubmit={testDatabaseConnection}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>

            <TextField
              label="Connection Name"
              name="secretName"
              value={formData.secretName}
              onChange={handleChange}
              required
              fullWidth
              inputProps={{ maxLength: 30 }}
              error={errors.secretName}
              helperText={
                errors.secretName
                  ? AWS_CONFIG_TYPE
                    ? 'Must start with a letter. Use only lowercase letters, numbers, and underscores (max 30 chars)'
                    : 'Must start with a letter. Use only lowercase letters, numbers, and hyphens (max 30 chars)'
                  : ''
              }
            />

            <Divider sx={{ my: 1, borderColor: '#ccc' }} />
            <TextField
              label="Storage Account Key"
              name="storageAccountKey"
              value={formData.storageAccountKey}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Storage Account"
              name="storageAccount"
              value={formData.storageAccount}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Container Name"
              name="containerName"
              value={formData.containerName}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Endpoint Suffix"
              name="endpointSuffix"
              value={formData.endpointSuffix}
              onChange={handleChange}
              required
              fullWidth
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 2 }}>
              Test
            </Button>

            <Button
              type="button"
              onClick={handleSubmit}
              variant="contained"
              color="success"
              disabled={!isConnectionSucceeded}
            >
              Save
            </Button>
          </Box>
        </form>
      </DialogContent>
      {loading && <LoadingIcon />}
    </Dialog>
  );
};

ADLSDatalakeConnectorForm.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  service: PropTypes.object,
};

export default ADLSDatalakeConnectorForm;
